import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

import { getSelectedLanguage } from './helpers/other'

import { defaultLocale } from './constants/language'

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: getSelectedLanguage(),
    fallbackLng: defaultLocale,
    backend: {
      /* translation file path */
      loadPath: '/translations/{{lng}}.json'
    },

    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    // If we want to use symbol like ":" in translations we must to set this:
    // https://github.com/i18next/react-i18next/issues/387#issuecomment-361503984
    nsSeparator: false
  })

export default i18n
